import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="header-container bg-dark-gray">
      <div className="logo-topleft"></div>
      <nav className="navigation">
        <a href="#about-me" className="nav-link">About</a>
        <a href="#skills" className="nav-link">Skills</a>
        <a href="#projects" className="nav-link">Projects</a>
        <a href="#experience" className="nav-link">Experience</a>
        <a href="#education" className="nav-link">Education</a>
        <a href="#socials" className="nav-link">Socials</a>
      </nav>
    </div>
  );
};

export default Header;
